import React, { createContext, useContext } from 'react';

export const ToasterContext = createContext({
  setToasterInfo : () => null
});

export const useToasterControls = () => {
  const controls = useContext(ToasterContext);
  return controls;
};